export default __webpack_public_path__ + "static/media/011_photo.cd124424.jpg";